module.exports = __webpack_public_path__ + "static/media/suse.a413c670.svg";